import script from "./DateOfBirthInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateOfBirthInput.vue?vue&type=script&setup=true&lang=ts"

import "./DateOfBirthInput.vue?vue&type=style&index=0&id=e6f80bee&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6f80bee"]])

export default __exports__